// Each practice app's tile for the app switcher and the dashboard (client
// 2026-11-03), named after the app. Imported rather than served from public/
// so the build hashes them into /assets and the service worker precaches
// them: they must show offline too.
//
// PNGs at 3x (432px wide), rendered from the .svg beside each one — the
// source. Safari draws an SVG's filters (the letters' shadows) at low
// resolution inside an <img> on Retina screens, which blurred the letters
// (client 2026-11-04); a PNG has them drawn at full resolution, as the
// in-game app's tiles are.
import quarterback from "./quarterback.png";
import runningBack from "./running-back.png";
import tightEnd from "./tight-end.png";
import offensiveLine from "./offensive-line.png";
import wideReceiver from "./wide-receiver.png";
import linebacker from "./linebacker.png";
import safety from "./safety.png";
import defensiveLine from "./defensive-line.png";
import defensiveBack from "./defensive-back.png";
import defensiveCoordinator from "./defensive-coordinator.png";
import specialTeams from "./special-teams.png";
import practice from "./practice.png";

/** By app id (the /qb, /rb… paths). */
export const APP_ICONS: Readonly<Record<string, string | undefined>> = {
  qb: quarterback,
  rb: runningBack,
  te: tightEnd,
  ol: offensiveLine,
  wr: wideReceiver,
  lb: linebacker,
  s: safety,
  dl: defensiveLine,
  db: defensiveBack,
  dc: defensiveCoordinator,
  st: specialTeams,
  def: practice,
};
